import { defaultEmployeeFormValues, EmployeeFormValues } from "../common/EmployeeFormValues";
import { Language } from "../enums/Language";
import { defaultDisabilityFormValues, DisabilityFormValues } from "./DisabilityFormValues";
import { DisabilityProduct } from "../enums/DisabilityProduct";
import { PregnancyDeliveryType } from "../enums/PregnancyDeliveryType";

export type DisabilityEmployeeFormValues = EmployeeFormValues & DisabilityFormValues & {
    textPermission: boolean,
    preferredLanguage: Language,
    otherLanguage: string,
    workState: string,
    workStateSameAsResidencyState: string,
    product: DisabilityProduct,
    conditionDetails: string,
    expectedDelivery: boolean,
    deliveryDate: string,
    deliveryType: PregnancyDeliveryType,
    otherDisabilityInsurer: boolean,
    claimDates: [{
        startDate: string
    }],
    motorVehicleAccident: boolean,
    workRelated: boolean,
    otherBenefits: boolean,
    hipaaConsent: boolean,
    confidentialMessages: string,
    permissionContactName: string,
    relationshipType: string,
    otherRelationshipDescription: string,
    representativeAuthority: string,
    authorityDescription: string,
    authorityDocumentation: string,
}

export const defaultDisabilityEmployeeFormValues = {
    ...defaultEmployeeFormValues,
    ...defaultDisabilityFormValues,
    textPermission: false,
    preferredLanguage: Language.ENGLISH,
    otherLanguage: '',
    workState: '',
    workStateSameAsResidencyState: '',
    product: '',
    conditionDetails: '',
    expectedDelivery: false,
    deliveryDate: "",
    deliveryType: "",
    otherDisabilityInsurer: false,
    claimDates: [{
        startDate: ''
    }],
    motorVehicleAccident: false,
    workRelated: false,
    otherBenefits: false,
    hipaaConsent: false,
    confidentialMessages: '',
    permissionContactName: '',
    relationshipType: '',
    otherRelationshipDescription: '',
    representativeAuthority: 'No',
    authorityDescription: '',
    authorityDocumentation: '',
}